export class Events {
  /**
   * Checks if keyboard keys for saving are pressed.
   * @param e KeyboardEvent
   */
  public static isKeyboardSave(e: KeyboardEvent): boolean {
    return (e.metaKey || e.ctrlKey) && e.code === 'KeyS';
  }

  /**
   * Checks if keyboard key for canceling is pressed.
   * @param e KeyboardEvent
   */
  public static isKeyboardCancel(e: KeyboardEvent): boolean {
    return e.key === 'Escape';
  }

  /**
   * Checks if keyboard keys for clearing are pressed.
   * @param e KeyboardEvent
   */
  public static isKeyboardClear(e: KeyboardEvent): boolean {
    return e.altKey && e.code === 'KeyC';
  }
}
